export const PHONE_PREFIX = {
  AF: {
    primary: 'AF',
    secondary: '+93'
  },
  AL: {
    primary: 'AL',
    secondary: '+355'
  },
  DE: {
    primary: 'DE',
    secondary: '+49'
  },
  DZ: {
    primary: 'DZ',
    secondary: '+213'
  },
  AD: {
    primary: 'AD',
    secondary: '+376'
  },
  AO: {
    primary: 'AO',
    secondary: '+244'
  },
  AI: {
    primary: 'AI',
    secondary: '+1264'
  },
  AQ: {
    primary: 'AQ',
    secondary: '+672'
  },
  AG: {
    primary: 'AG',
    secondary: '+1268'
  },
  AN: {
    primary: 'AN',
    secondary: '+599'
  },
  SA: {
    primary: 'SA',
    secondary: '+966'
  },
  AR: {
    primary: 'AR',
    secondary: '+54'
  },
  AM: {
    primary: 'AM',
    secondary: '+374'
  },
  AW: {
    primary: 'AW',
    secondary: '+297'
  },
  AU: {
    primary: 'AU',
    secondary: '+61'
  },
  AT: {
    primary: 'AT',
    secondary: '+43'
  },
  AZ: {
    primary: 'AZ',
    secondary: '+994'
  },
  BE: {
    primary: 'BE',
    secondary: '+32'
  },
  BS: {
    primary: 'BS',
    secondary: '+1242'
  },
  BH: {
    primary: 'BH',
    secondary: '+973'
  },
  BD: {
    primary: 'BD',
    secondary: '+880'
  },
  BB: {
    primary: 'BB',
    secondary: '+1246'
  },
  BZ: {
    primary: 'BZ',
    secondary: '+501'
  },
  BJ: {
    primary: 'BJ',
    secondary: '+229'
  },
  BT: {
    primary: 'BT',
    secondary: '+975'
  },
  BY: {
    primary: 'BY',
    secondary: '+375'
  },
  MM: {
    primary: 'MM',
    secondary: '+95'
  },
  BO: {
    primary: 'BO',
    secondary: '+591'
  },
  BA: {
    primary: 'BA',
    secondary: '+387'
  },
  BW: {
    primary: 'BW',
    secondary: '+267'
  },
  BR: {
    primary: 'BR',
    secondary: '+55'
  },
  BN: {
    primary: 'BN',
    secondary: '+673'
  },
  BG: {
    primary: 'BG',
    secondary: '+359'
  },
  BF: {
    primary: 'BF',
    secondary: '+226'
  },
  BI: {
    primary: 'BI',
    secondary: '+257'
  },
  CV: {
    primary: 'CV',
    secondary: '+238'
  },
  KH: {
    primary: 'KH',
    secondary: '+855'
  },
  CM: {
    primary: 'CM',
    secondary: '+237'
  },
  CA: {
    primary: 'CA',
    secondary: '+1'
  },
  TD: {
    primary: 'TD',
    secondary: '+235'
  },
  CL: {
    primary: 'CL',
    secondary: '+56'
  },
  CN: {
    primary: 'CN',
    secondary: '+86'
  },
  CY: {
    primary: 'CY',
    secondary: '+357'
  },
  VA: {
    primary: 'VA',
    secondary: '+39'
  },
  CO: {
    primary: 'CO',
    secondary: '+57'
  },
  KM: {
    primary: 'KM',
    secondary: '+269'
  },
  CG: {
    primary: 'CG',
    secondary: '+242'
  },
  CD: {
    primary: 'CD',
    secondary: '+243'
  },
  KP: {
    primary: 'KP',
    secondary: '+850'
  },
  KR: {
    primary: 'KR',
    secondary: '+82'
  },
  CI: {
    primary: 'CI',
    secondary: '+225'
  },
  CR: {
    primary: 'CR',
    secondary: '+506'
  },
  HR: {
    primary: 'HR',
    secondary: '+385'
  },
  CU: {
    primary: 'CU',
    secondary: '+53'
  },
  DK: {
    primary: 'DK',
    secondary: '+45'
  },
  DM: {
    primary: 'DM',
    secondary: '+1767'
  },
  EC: {
    primary: 'EC',
    secondary: '+593'
  },
  EG: {
    primary: 'EG',
    secondary: '+20'
  },
  SV: {
    primary: 'SV',
    secondary: '+503'
  },
  AE: {
    primary: 'AE',
    secondary: '+971'
  },
  ER: {
    primary: 'ER',
    secondary: '+291'
  },
  SK: {
    primary: 'SK',
    secondary: '+421'
  },
  SI: {
    primary: 'SI',
    secondary: '+386'
  },
  ES: {
    primary: 'ES',
    secondary: '+34'
  },
  US: {
    primary: 'US',
    secondary: '+1'
  },
  EE: {
    primary: 'EE',
    secondary: '+372'
  },
  ET: {
    primary: 'ET',
    secondary: '+251'
  },
  PH: {
    primary: 'PH',
    secondary: '+63'
  },
  FI: {
    primary: 'FI',
    secondary: '+358'
  },
  FJ: {
    primary: 'FJ',
    secondary: '+679'
  },
  FR: {
    primary: 'FR',
    secondary: '+33'
  },
  GA: {
    primary: 'GA',
    secondary: '+241'
  },
  GM: {
    primary: 'GM',
    secondary: '+220'
  },
  GE: {
    primary: 'GE',
    secondary: '+995'
  },
  GH: {
    primary: 'GH',
    secondary: '+233'
  },
  GI: {
    primary: 'GI',
    secondary: '+350'
  },
  GD: {
    primary: 'GD',
    secondary: '+1473'
  },
  GR: {
    primary: 'GR',
    secondary: '+30'
  },
  GL: {
    primary: 'GL',
    secondary: '+299'
  },
  GU: {
    primary: 'GU',
    secondary: '+1671'
  },
  GT: {
    primary: 'GT',
    secondary: '+502'
  },
  GN: {
    primary: 'GN',
    secondary: '+224'
  },
  GQ: {
    primary: 'GQ',
    secondary: '+240'
  },
  GW: {
    primary: 'GW',
    secondary: '+245'
  },
  GY: {
    primary: 'GY',
    secondary: '+592'
  },
  HT: {
    primary: 'HT',
    secondary: '+509'
  },
  HN: {
    primary: 'HN',
    secondary: '+504'
  },
  HK: {
    primary: 'HK',
    secondary: '+852'
  },
  HU: {
    primary: 'HU',
    secondary: '+36'
  },
  IN: {
    primary: 'IN',
    secondary: '+91'
  },
  ID: {
    primary: 'ID',
    secondary: '+62'
  },
  IR: {
    primary: 'IR',
    secondary: '+98'
  },
  IQ: {
    primary: 'IQ',
    secondary: '+964'
  },
  IE: {
    primary: 'IE',
    secondary: '+353'
  },
  IM: {
    primary: 'IM',
    secondary: '+44'
  },
  CX: {
    primary: 'CX',
    secondary: '+61'
  },
  NF: {
    primary: 'NF',
    secondary: '+'
  },
  IS: {
    primary: 'IS',
    secondary: '+354'
  },
  BM: {
    primary: 'BM',
    secondary: '+1441'
  },
  KY: {
    primary: 'KY',
    secondary: '+1345'
  },
  CC: {
    primary: 'CC',
    secondary: '+61'
  },
  CK: {
    primary: 'CK',
    secondary: '+682'
  },
  FO: {
    primary: 'FO',
    secondary: '+298'
  },
  MV: {
    primary: 'MV',
    secondary: '+960'
  },
  FK: {
    primary: 'FK',
    secondary: '+500'
  },
  MP: {
    primary: 'MP',
    secondary: '+1670'
  },
  MH: {
    primary: 'MH',
    secondary: '+692'
  },
  PN: {
    primary: 'PN',
    secondary: '+870'
  },
  SB: {
    primary: 'SB',
    secondary: '+677'
  },
  TC: {
    primary: 'TC',
    secondary: '+1649'
  },
  VG: {
    primary: 'VG',
    secondary: '+1284'
  },
  VI: {
    primary: 'VI',
    secondary: '+1340'
  },
  IL: {
    primary: 'IL',
    secondary: '+972'
  },
  IT: {
    primary: 'IT',
    secondary: '+39'
  },
  JM: {
    primary: 'JM',
    secondary: '+1876'
  },
  JP: {
    primary: 'JP',
    secondary: '+81'
  },
  JO: {
    primary: 'JO',
    secondary: '+962'
  },
  KZ: {
    primary: 'KZ',
    secondary: '+7'
  },
  KE: {
    primary: 'KE',
    secondary: '+254'
  },
  KG: {
    primary: 'KG',
    secondary: '+996'
  },
  KI: {
    primary: 'KI',
    secondary: '+686'
  },
  KW: {
    primary: 'KW',
    secondary: '+965'
  },
  LB: {
    primary: 'LB',
    secondary: '+961'
  },
  LA: {
    primary: 'LA',
    secondary: '+856'
  },
  LS: {
    primary: 'LS',
    secondary: '+266'
  },
  LV: {
    primary: 'LV',
    secondary: '+371'
  },
  LR: {
    primary: 'LR',
    secondary: '+231'
  },
  LY: {
    primary: 'LY',
    secondary: '+218'
  },
  LI: {
    primary: 'LI',
    secondary: '+423'
  },
  LT: {
    primary: 'LT',
    secondary: '+370'
  },
  LU: {
    primary: 'LU',
    secondary: '+352'
  },
  MX: {
    primary: 'MX',
    secondary: '+52'
  },
  MC: {
    primary: 'MC',
    secondary: '+377'
  },
  MO: {
    primary: 'MO',
    secondary: '+853'
  },
  MK: {
    primary: 'MK',
    secondary: '+389'
  },
  MG: {
    primary: 'MG',
    secondary: '+261'
  },
  MY: {
    primary: 'MY',
    secondary: '+60'
  },
  MW: {
    primary: 'MW',
    secondary: '+265'
  },
  ML: {
    primary: 'ML',
    secondary: '+223'
  },
  MT: {
    primary: 'MT',
    secondary: '+356'
  },
  MA: {
    primary: 'MA',
    secondary: '+212'
  },
  MU: {
    primary: 'MU',
    secondary: '+230'
  },
  MR: {
    primary: 'MR',
    secondary: '+222'
  },
  YT: {
    primary: 'YT',
    secondary: '+262'
  },
  FM: {
    primary: 'FM',
    secondary: '+691'
  },
  MD: {
    primary: 'MD',
    secondary: '+373'
  },
  MN: {
    primary: 'MN',
    secondary: '+976'
  },
  ME: {
    primary: 'ME',
    secondary: '+382'
  },
  MS: {
    primary: 'MS',
    secondary: '+1664'
  },
  MZ: {
    primary: 'MZ',
    secondary: '+258'
  },
  NA: {
    primary: 'NA',
    secondary: '+264'
  },
  NR: {
    primary: 'NR',
    secondary: '+674'
  },
  NP: {
    primary: 'NP',
    secondary: '+977'
  },
  NI: {
    primary: 'NI',
    secondary: '+505'
  },
  NE: {
    primary: 'NE',
    secondary: '+227'
  },
  NG: {
    primary: 'NG',
    secondary: '+234'
  },
  NU: {
    primary: 'NU',
    secondary: '+683'
  },
  NO: {
    primary: 'NO',
    secondary: '+47'
  },
  NC: {
    primary: 'NC',
    secondary: '+687'
  },
  NZ: {
    primary: 'NZ',
    secondary: '+64'
  },
  OM: {
    primary: 'OM',
    secondary: '+968'
  },
  NL: {
    primary: 'NL',
    secondary: '+31'
  },
  PK: {
    primary: 'PK',
    secondary: '+92'
  },
  PW: {
    primary: 'PW',
    secondary: '+680'
  },
  PA: {
    primary: 'PA',
    secondary: '+507'
  },
  PG: {
    primary: 'PG',
    secondary: '+675'
  },
  PY: {
    primary: 'PY',
    secondary: '+595'
  },
  PE: {
    primary: 'PE',
    secondary: '+51'
  },
  PF: {
    primary: 'PF',
    secondary: '+689'
  },
  PL: {
    primary: 'PL',
    secondary: '+48'
  },
  PT: {
    primary: 'PT',
    secondary: '+351'
  },
  PR: {
    primary: 'PR',
    secondary: '+1'
  },
  QA: {
    primary: 'QA',
    secondary: '+974'
  },
  GB: {
    primary: 'GB',
    secondary: '+44'
  },
  CF: {
    primary: 'CF',
    secondary: '+236'
  },
  CZ: {
    primary: 'CZ',
    secondary: '+420'
  },
  DO: {
    primary: 'DO',
    secondary: '+1809'
  },
  RW: {
    primary: 'RW',
    secondary: '+250'
  },
  RO: {
    primary: 'RO',
    secondary: '+40'
  },
  RU: {
    primary: 'RU',
    secondary: '+7'
  },
  WS: {
    primary: 'WS',
    secondary: '+685'
  },
  AS: {
    primary: 'AS',
    secondary: '+1684'
  },
  BL: {
    primary: 'BL',
    secondary: '+590'
  },
  KN: {
    primary: 'KN',
    secondary: '+1869'
  },
  SM: {
    primary: 'SM',
    secondary: '+378'
  },
  MF: {
    primary: 'MF',
    secondary: '+1599'
  },
  PM: {
    primary: 'PM',
    secondary: '+508'
  },
  VC: {
    primary: 'VC',
    secondary: '+1784'
  },
  SH: {
    primary: 'SH',
    secondary: '+290'
  },
  LC: {
    primary: 'LC',
    secondary: '+1758'
  },
  ST: {
    primary: 'ST',
    secondary: '+239'
  },
  SN: {
    primary: 'SN',
    secondary: '+221'
  },
  RS: {
    primary: 'RS',
    secondary: '+381'
  },
  SC: {
    primary: 'SC',
    secondary: '+248'
  },
  SL: {
    primary: 'SL',
    secondary: '+232'
  },
  SG: {
    primary: 'SG',
    secondary: '+65'
  },
  SY: {
    primary: 'SY',
    secondary: '+963'
  },
  SO: {
    primary: 'SO',
    secondary: '+252'
  },
  LK: {
    primary: 'LK',
    secondary: '+94'
  },
  ZA: {
    primary: 'ZA',
    secondary: '+27'
  },
  SD: {
    primary: 'SD',
    secondary: '+249'
  },
  SE: {
    primary: 'SE',
    secondary: '+46'
  },
  CH: {
    primary: 'CH',
    secondary: '+41'
  },
  SR: {
    primary: 'SR',
    secondary: '+597'
  },
  SZ: {
    primary: 'SZ',
    secondary: '+268'
  },
  TJ: {
    primary: 'TJ',
    secondary: '+992'
  },
  TH: {
    primary: 'TH',
    secondary: '+66'
  },
  TW: {
    primary: 'TW',
    secondary: '+886'
  },
  TZ: {
    primary: 'TZ',
    secondary: '+255'
  },
  TL: {
    primary: 'TL',
    secondary: '+670'
  },
  TG: {
    primary: 'TG',
    secondary: '+228'
  },
  TK: {
    primary: 'TK',
    secondary: '+690'
  },
  TO: {
    primary: 'TO',
    secondary: '+676'
  },
  TT: {
    primary: 'TT',
    secondary: '+1868'
  },
  TN: {
    primary: 'TN',
    secondary: '+216'
  },
  TM: {
    primary: 'TM',
    secondary: '+993'
  },
  TR: {
    primary: 'TR',
    secondary: '+90'
  },
  TV: {
    primary: 'TV',
    secondary: '+688'
  },
  UA: {
    primary: 'UA',
    secondary: '+380'
  },
  UG: {
    primary: 'UG',
    secondary: '+256'
  },
  UY: {
    primary: 'UY',
    secondary: '+598'
  },
  UZ: {
    primary: 'UZ',
    secondary: '+998'
  },
  VU: {
    primary: 'VU',
    secondary: '+678'
  },
  VE: {
    primary: 'VE',
    secondary: '+58'
  },
  VN: {
    primary: 'VN',
    secondary: '+84'
  },
  WF: {
    primary: 'WF',
    secondary: '+681'
  },
  YE: {
    primary: 'YE',
    secondary: '+967'
  },
  DJ: {
    primary: 'DJ',
    secondary: '+253'
  },
  ZM: {
    primary: 'ZM',
    secondary: '+260'
  },
  ZW: {
    primary: 'ZW',
    secondary: '+263'
  }
};

export const OBJECTION_MSG_ADMIN_KEY = 'AdminObjectionNotification';

export const OBJECTION_MSG_KEY = 'ObjectionNotification';

export const inputName = (name) => {
  switch (name) {
    case 'citySign':
      return 'Ciudad de firma de contrato';
    case 'dateSign':
      return 'Fecha de firma de contrato';
    case 'lessor_gender':
      return 'Sexo arrendador';
    case 'lessor_firstName':
      return 'Primer nombre arrendador';
    case 'lessor_lastName':
      return 'Primer apellido arrendador';
    case 'lessor_rut':
      return 'Rut arrendador';
    case 'lessor_nationality':
      return 'Nacionalidad de arrendador';
    case 'lessor_civilStatus':
      return 'Estado civil arrendador';
    case 'lessor_profession':
      return 'Profesión de arrendador';
    case 'lessor_address':
      return 'Dirección de arrendador';
    case 'lessor_commune':
      return 'Comuna de arrendador';
    case 'lessor_cedFront':
      return 'Imagen frontal cédula de identidad arrendador';
    case 'lessor_cedBack':
      return 'Imagen reversa cédula de identidad arrendador';
    case 'lessor_email':
      return 'Email de arrendador';
    case 'lessor_confirmEmail':
      return 'Confirmar email de arrendador';
    case 'lessor_phoneNumber':
      return 'Número de telefono arrendador';
    case 'lessee_gender':
      return 'Sexo arrendatario';
    case 'lessee_firstName':
      return 'Primer nombre arrendatario';
    case 'lessee_lastName':
      return 'Primer apellido arrendatario';
    case 'lessee_rut':
      return 'Rut arrendatario';
    case 'lessee_nationality':
      return 'Nacionalidad de arrendatario';
    case 'lessee_civilStatus':
      return 'Estado civil arrendatario';
    case 'lessee_profession':
      return 'Profesión de arrendatario';
    case 'lessee_address':
      return 'Dirección de arrendatario';
    case 'lessee_commune':
      return 'Comuna de arrendatario';
    case 'lessee_gedFront':
      return 'Imagen frontal cédula de identidad arrendatario';
    case 'lessee_cedBack':
      return 'Imagen reversa cédula de identidad arrendatario';
    case 'lessee_email':
      return 'Email de arrendatario';
    case 'lessee_confirmEmail':
      return 'Confirmar email de arrendatario';
    case 'lessee_phoneNumber':
      return 'Número de telefono arrendatario';
    case 'codebtor_hasCodebtor':
      return 'Debe indicar si existe codeudor';
    case 'codebtor_gender':
      return 'Sexo codeudor';
    case 'codebtor_firstName':
      return 'Primer nombre codeudor';
    case 'codebtor_lastName':
      return 'Primer apellido codeudor';
    case 'codebtor_rut':
      return 'Rut codeudor';
    case 'codebtor_nationality':
      return 'Nacionalidad de codeudor';
    case 'codebtor_civilStatus':
      return 'Estado civil codeudor';
    case 'codebtor_profession':
      return 'Profesión de codeudor';
    case 'codebtor_address':
      return 'Dirección de codeudor';
    case 'codebtor_commune':
      return 'Comuna de codeudor';
    case 'codebtor_cedFront':
      return 'Imagen frontal cédula de identidad codeudor';
    case 'codebtor_cedBack':
      return 'Imagen reversa cédula de identidad codeudor';
    case 'codebtor_email':
      return 'Email de codeudor';
    case 'codebtor_confirmEmail':
      return 'Confirmar email de codeudor';
    case 'codebtor_phoneNumber':
      return 'Número de telefono codeudor';
    case 'typeOfHousing':
      return 'Tipo de inmueble';
    case 'homeAddress':
      return 'Dirección del inmueble';
    case 'homeCommune':
      return 'Comuna de inmueble';
    case 'hasParking':
      return 'Tiene estacionamiento';
    case 'hasWarehouse':
      return 'Tiene bodega';
    case 'initialLeaseDate':
      return 'Fecha de arriendo';
    case 'contractDurationNumber':
      return 'Numero duración de contrato';
    case 'contractDurationRange':
      return 'Rango de duración de contrato';
    case 'paymentPeriod':
      return 'Periodo de pago de arriendo';
    case 'autoRenewal':
      return 'Contrato se renueva automaticamente';
    case 'typeOfCurrency':
      return 'Tipo de divisa';
    case 'monthlyRent':
      return 'Valor mensual de arriendo';
    case 'guaranteeAmount':
      return 'Monto de garantía';
    case 'finesType':
      return 'Divisa de multa';
    case 'finesAmount':
      return 'Montino de multa';
    case 'petBan':
      return 'Se prohibe tener mascotas';
    case 'payCommonExpenses':
      return 'Se tiene que pagar gastos comunes';
    case 'IPCAdjustment':
      return 'Tiempo de reajuste de valor de arriendo';
    case 'paymentType':
      return 'Tipo de pago';
    case 'typeBankAccount':
      return 'Tipo de cuenta';
    case 'accountNumber':
      return 'Numero de cuenta';
    case 'holdersName':
      return 'Nombre titual cuenta';
    case 'holdersRut':
      return 'Rut de titular';
    case 'notificationEmail':
      return 'Email notificación a titular';
    case 'sanction':
      return 'Arrendatario tendrá sanción';
    case 'lessor_businessName':
    case 'lessee_businessName':
    case 'codebtor_businessName':
      return 'razón social persona juridica';
    case 'lessor_giro':
    case 'lessee_giro':
    case 'codebtor_giro':
      return 'giro persona juridica';
    case 'lessor_companyRol':
    case 'lessee_companyRol':
    case 'codebtor_companyRol':
      return 'rut persona juridica';
    case 'lessor_dateOfconstitution':
    case 'lessee_dateOfconstitution':
    case 'codebtor_dateOfconstitution':
      return 'fecha de poder';
    case 'lessor_constitutionNotary':
    case 'lessee_constitutionNotary':
    case 'codebtor_constitutionNotary':
      return 'notaría de poder';
    case 'lessor_certificateFileArray':
    case 'lessee_certificateFileArray':
    case 'codebtor_certificateFileArray':
      return 'certificado de poder';
    default:
      return 'campos faltantes';
  };
};